import { Card } from '../../../shared/components/ui/card';

type ProviderDetailsCareDeliveryProps = {
  priceDetails: string | null;
  carePhilosophy: string | null;
  emergencyResponseDetails: string | null;
};

export const ProviderDetailsCareDelivery = ({
  priceDetails,
  carePhilosophy,
  emergencyResponseDetails,
}: ProviderDetailsCareDeliveryProps) => {
  // Check if we have any content to display
  const hasAnyContent = priceDetails || carePhilosophy || emergencyResponseDetails;

  return (
    <div className="space-y-8">
      {/* Page Header */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Care Delivery</h2>
        <p className="text-gray-600 mt-2">
          Pricing Overview, Care Philosophy, and Emergency Response
        </p>
      </div>

      {/* Pricing Overview Section */}
      {priceDetails && (
        <Card className="p-6">
          <h3 className="text-xl font-semibold text-gray-900 mb-3">
            Pricing Overview
          </h3>
          <div className="text-gray-700 whitespace-pre-wrap">
            {priceDetails}
          </div>
        </Card>
      )}

      {/* Care Philosophy Section */}
      {carePhilosophy && (
        <Card className="p-6">
          <h3 className="text-xl font-semibold text-gray-900 mb-3">
            Care Philosophy
          </h3>
          <div className="text-gray-700 whitespace-pre-wrap">
            {carePhilosophy}
          </div>
        </Card>
      )}

      {/* Emergency Response Details Section */}
      {emergencyResponseDetails && (
        <Card className="p-6">
          <h3 className="text-xl font-semibold text-gray-900 mb-3">
            Emergency Response Details
          </h3>
          <div className="text-gray-700 whitespace-pre-wrap">
            {emergencyResponseDetails}
          </div>
        </Card>
      )}

      {/* Empty State */}
      {!hasAnyContent && (
        <div className="text-center py-12">
          <p className="text-gray-500 italic">
            This provider has not provided care delivery information yet.
          </p>
        </div>
      )}
    </div>
  );
};
